import React from "react";

const socialPlatforms = [
  { name: "Discord", icon: "fab fa-discord", href: "https://discord.com/invite/SqbByMnDTv", color: "#5865F2" },
  { name: "Instagram", icon: "fab fa-instagram", href: "https://www.instagram.com/cges.club/", color: "#E1306C" },
  { name: "YouTube", icon: "fab fa-youtube", href: "https://www.youtube.com/channel/UCuI03JhLpF4Bb6EZ-AWqPfg", color: "#FF0000" },
  { name: "LinkedIn", icon: "fab fa-linkedin-in", href: "https://www.linkedin.com/company/cges-club/", color: "#0A66C2" },
  { name: "Twitch", icon: "fab fa-twitch", href: "https://www.twitch.tv/cges_club", color: "#9146FF" },
];

export default function Social() {
  return (
    <section className="home-social-card">
      <span className="home-connect-chip">Follow Us</span>
      <h3>Join our social universe.</h3>
      <p>
        Stay connected for live streams, updates, event clips, and community
        announcements.
      </p>
      <div className="home-social-meta">
        <span>25K+ community followers</span>
      </div>
      <div className="home-social-links">
        {socialPlatforms.map((platform) => (
          <a
            key={platform.name}
            href={platform.href}
            className="home-social-link"
            aria-label={platform.name}
            style={{ "--platform-color": platform.color }}
            target="__blank"
          >
            <div className="home-social-link-left">
              <i className={platform.icon} aria-hidden="true"></i>
              <span>{platform.name}</span>
            </div>
            <i className="fas fa-chevron-right home-social-arrow" aria-hidden="true"></i>
          </a>
        ))}
      </div>
    </section>
  );
}
